import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import plusimg from "../assets/images/dasboard/pluse.webp";
import minusimg from "../assets/images/dasboard/minus.webp";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { POST_WEIGHT_UPDATE } from "../config/ApisCollection";
import validation_rule from "../config/Validations.json";

const WeightUpdatePopup = ({
  isWeightUpdateOpen,
  setIsWeightUpdateOpen,
  currentWeightValue,
  handleDashboardApi,
}) => {
  const [weightnum, setWeightNum] = useState(currentWeightValue);
  const [msg, setMsg] = useState(null);
  const accessToken = secureLocalStorage.getItem("accessToken");
  // console.log(currentWeightValue);

  const UpdateWeight = async () => {
    setMsg("Proccessing");
    const post_body = {
      weight: weightnum,
      weightunit: currentWeightValue?.weightType,
    };

    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(POST_WEIGHT_UPDATE, post_body, post_header)
        .then((response) => {
          secureLocalStorage.removeItem("profileDetails");
          setMsg("Weight updated successfully...");
          handleDashboardApi();
        });
    } catch (error) {
      console.log(error);
      // if (
      //   error?.response?.data?.error?.message === "token expired" &&
      //   secureLocalStorage.getItem("refreshToken")
      // ) {
      //   dispatch(refreshToken2());
      // } else if (error?.response?.data?.error?.message === "token expired") {
      //   secureLocalStorage.clear();
      //   history("/login");
      // }
    }

    setTimeout(() => {
      setMsg(null);
      setIsWeightUpdateOpen(false);
    }, 3000);
  };

  useEffect(() => {
    setWeightNum(currentWeightValue?.latestWeight);
  }, [currentWeightValue]);

  return (
    <Popup
      open={isWeightUpdateOpen}
      onClose={() => {
        setIsWeightUpdateOpen(false);
      }}
      position="right center"
    >
      <div>
        <h1 className="text-center text-xl">
          How much do you
          <span className="text-orange"> weight today</span>?
        </h1>
        <p className="text-xs text-center mt-2">
          We recommend measuring the weight at the same time daily.
        </p>
      </div>
      <div className="flex justify-evenly py-10 px-5 gap-5">
        <div className="flex flex-col p-2 text-center rounded-2xl justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (
                (currentWeightValue.weightType == "kg" &&
                  weightnum > validation_rule?.currentWeightkgMin) ||
                (currentWeightValue.weightType == "lb" &&
                  weightnum > validation_rule?.currentWeightLbMin)
              ) {
                setWeightNum(weightnum - 1);
              }
            }}
          >
            <img src={minusimg} className="m-auto" />
          </button>
        </div>
        <div className="flex flex-col p-2 text-center gap-2">
          <h1 className="text-6xl">{weightnum}</h1>
          <h1 className="text-xl">{currentWeightValue.weightType}</h1>
        </div>
        <div className="flex flex-col p-2 text-center  justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (
                (currentWeightValue.weightType == "kg" &&
                  weightnum < validation_rule?.currentWeightKgMax) ||
                (currentWeightValue.weightType == "lb" &&
                  weightnum < validation_rule?.currentWeightLbMax)
              ) {
                setWeightNum(weightnum + 1);
              }
            }}
          >
            <img src={plusimg} className="m-auto" />
          </button>
        </div>
      </div>
      <div className="items-center ">
        {/* <h1 className="text-center text-xs !mb-3">1 glass = 250 ml </h1> */}
        <h1 className="text-center text-xs !mb-3 text-[#28a745]">{msg} </h1>
        {msg != "Proccessing" ? (
          <button
            className="px-5 py-2 text-center bg-orange !text-[#fff] rounded-xl shadow-2xl w-full "
            onClick={UpdateWeight}
          >
            Update Weight
          </button>
        ) : (
          <></>
        )}
      </div>
    </Popup>
  );
};

export default WeightUpdatePopup;
